import { Challenges } from '../editor/types/Experiments';

interface Experiments {
  get(key: string): string | undefined;
}

interface GetInviteLinkParams {
  baseUrl: string;
  programId: string;
  msid: string;
  experiments: Experiments;
}

export function getInviteLink({
  baseUrl,
  programId,
  msid,
  experiments,
}: GetInviteLinkParams): string {
  const inviteLink = `${baseUrl}/_serverless/challenges-web-serverless/redirect-invite-link?programId=${programId}`;

  if (experiments.get(Challenges.secureBmInviteLinks) === 'B') {
    return inviteLink;
  }

  return `${inviteLink}&msid=${msid}`;
}
